import * as yup from 'yup';
import {
  investmentDateField,
  investmentTypeField,
  shareClassNameField,
  usdField,
  ViewModelInvestmentType,
} from './common-schema-defs';
import { abstractShareClassSchema } from './AbstractShareClass.schema';

export const CashSchema = {
  create() {
    return abstractShareClassSchema().shape({
      type: investmentTypeField().default(ViewModelInvestmentType.cash),
      name: shareClassNameField().default('Cash'),
      cashRaised: usdField().required().label('Amount').default(0.0),
      investmentDate: investmentDateField(),
    });
  },
};

export type Cash = yup.InferType<ReturnType<typeof CashSchema.create>>;
export function createCash(overrides: Partial<Cash> = {}): Cash {
  return CashSchema.create().cast(overrides);
}
